"use client";

import React, { createContext, useContext, useEffect, useState } from "react";
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from "../utils/env.config";

interface ScreenContextType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const ScreenContext = createContext<ScreenContextType>({
  isMobile: false,
  isTablet: false,
  isDesktop: true,
});

export const ScreenProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isTablet, setIsTablet] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isDesktop, setIsDesktop] = useState<boolean>(false);

  useEffect(() => {
    const updateScreenSizes = () => {
      const width = window.innerWidth;
      setIsTablet(width < (+TABLET_BREAKPOINT) && width >= (+MOBILE_BREAKPOINT));
      setIsMobile(width < (+MOBILE_BREAKPOINT));
      setIsDesktop(width >= (+TABLET_BREAKPOINT));
      // console.log("Screen sizes updated:", {
      //   isMobile: width < (+MOBILE_BREAKPOINT),
      //   isTablet: width < (+TABLET_BREAKPOINT) && width >= (+MOBILE_BREAKPOINT),
      //   isDesktop: width >= (+TABLET_BREAKPOINT)
      // });
    };

    updateScreenSizes(); // Initial run

    window.addEventListener("resize", updateScreenSizes);
    return () => window.removeEventListener("resize", updateScreenSizes);
  }, []);

  return (
    <ScreenContext.Provider value={{ isMobile, isTablet, isDesktop }}>
      {children}
    </ScreenContext.Provider>
  );
};

export const useScreen = () => useContext(ScreenContext);
